import { nameof } from "@libs/utils/name-of.utils.ts";
import { required } from "@libs/validation/fieldValidators.ts";
import { Validator } from "@libs/validation/Validator.ts";

import { XeroAccountMappingFormValues } from "./XeroAccountMappingForm.tsx";

export class XeroAccountMappingFromValidator extends Validator<XeroAccountMappingFormValues> {
  constructor() {
    super();
    this.forField(nameof("invoiceAccountId"), [required()]);
    this.forField(nameof("paymentAccountId"), [required()]);
    this.forField(nameof("unallocatedAccountId"), [required()]);
  }
}
